/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import { useSelector } from 'react-redux';
import { useTheme, useMediaQuery } from '@material-ui/core';

import { featureSelector } from 'reducers/app.reducer';
import { ICustomTheme } from 'interfaces';
import Legals from 'components/Legals';
import { StyledAppLogo, StyledLegalsContainer } from './styles';

export const LegalBanner: React.FC = () => {
  const theme: ICustomTheme = useTheme();
  const isDesktop = !useMediaQuery(theme.breakpoints.down('sm'));
  const storeFeature = useSelector(featureSelector('use_store'));
  const isStoreEnabled = storeFeature?.data?.enabled;

  return (
    <StyledLegalsContainer isDesktop={isDesktop}>
      <StyledAppLogo />
      <div>
        <Legals
          textProps={{ align: isDesktop ? 'right' : 'center' }}
          isStoreEnabled={isStoreEnabled}
        />
      </div>
    </StyledLegalsContainer>
  );
};

export default LegalBanner;
